import createLiveDiscussion from './createLiveDiscussion';
import duplicateLiveDiscussion from './duplicateLiveDiscussion';
import joinLiveDiscussion from './joinLiveDiscussion';
import loadLiveDiscussion from './loadLiveDiscussion';
import saveLiveDiscussion from './saveLiveDiscussion';
import publishLiveDiscussion from './publishLiveDiscussion';
import startLiveDiscussion from './startLiveDiscussion';
import switchStudent from './switchStudent';
import togglePause from './togglePause';
import end from './end';
import restart from './restart';
import nudge from './nudge';
import togglePoints from './togglePoints';
import givePoint from './givePoint';
import observations from './observations';
import classSummaryLD from './classSummaryLD';
import forceJoinStudents from './forceJoinStudents';
import removeStudent from './removeStudent';
import removeStudents from './removeStudents';
import sendFeedback from './sendFeedback';
import deleteDiscussion from './deleteDiscussion';
import addDraftFeedbackForStudent from './addDraftFeedbackForStudent';
import addFeedbackForStudent from './addFeedbackForStudent';
import studentSummaryLD from './studentSummaryLD';
import getAllStudentNotes from './getAllStudentNotes';
import publishStudentNotes from './publishStudentNotes';
import getSummaryTableData from './getSummaryTableData';
import createPoll from './createPoll';
import editPoll from './editPoll';
import votePoll from './votePoll';
import getPollVote from './getPollVote';
import deletePoll from './deletePoll';
import getAllPolls from './getAllPolls';
import getPoll from './getPoll';
import toggleQueue from './toggleQueue';
import selectSavedFeedbackLD from './selectSavedFeedbackLD';
import getAgoraRTCConnection from './getAgoraRTCconnection';
import addLiveDiscussionToUniverse from './addLiveDiscussionToUniverse';
import syncLDAssessmentData from './syncLDAssessmentData';
import syncCourseWork from './syncCourseWork';
import gradeClassroomStudents from './gradeClassroomStudents';
import gradeClassroomStudentsJobStatus from './gradeGoogleClassroomStudentsJobStatus';
import openParticipation from './openParticipation';
import handleSaveUserTranscript from './handleSaveUserTranscript';
import getAgoraRTCConnectionScreen from './getAgoraRTCconnectionScreen';

export default {
  createLiveDiscussion,
  duplicateLiveDiscussion,
  loadLiveDiscussion,
  saveLiveDiscussion,
  publishLiveDiscussion,
  joinLiveDiscussion,
  startLiveDiscussion,
  switchStudent,
  togglePause,
  end,
  getSummaryTableData,
  restart,
  nudge,
  togglePoints,
  observations,
  classSummaryLD,
  forceJoinStudents,
  removeStudent,
  removeStudents,
  sendFeedback,
  givePoint,
  deleteDiscussion,
  addDraftFeedbackForStudent,
  addFeedbackForStudent,
  studentSummaryLD,
  getAllStudentNotes,
  publishStudentNotes,
  getPoll,
  createPoll,
  editPoll,
  votePoll,
  getPollVote,
  deletePoll,
  getAllPolls,
  toggleQueue,
  selectSavedFeedbackLD,
  getAgoraRTCConnection,
  addLiveDiscussionToUniverse,
  syncLDAssessmentData,
  syncCourseWork,
  gradeClassroomStudents,
  gradeClassroomStudentsJobStatus,
  openParticipation,
  handleSaveUserTranscript,
  getAgoraRTCConnectionScreen
};



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/index.js